import { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../utils/firebase';

/**
 * useUserAddedLocations
 * Fetches all company location records where source = 'userAdded'.
 */
function useUserAddedLocations() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchLocations() {
      try {
        setLoading(true);
        setError(null);

        const collRef = collection(db, 'companyLocationRecords');
        const qry = query(collRef, where('source', '==', 'userAdded'));
        const snap = await getDocs(qry);

        if (cancelled) return;

        const locationList = snap.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            ...data,
          };
        });

        // Sort by created date (newest first)
        locationList.sort((a, b) => {
          const dateA = a.timestamps?.createdDate;
          const dateB = b.timestamps?.createdDate;
          
          // Convert to numeric value: handle Firestore Timestamp objects
          const dateANum = dateA?.toMillis?.() ?? dateA?.valueOf?.() ?? dateA ?? 0;
          const dateBNum = dateB?.toMillis?.() ?? dateB?.valueOf?.() ?? dateB ?? 0;
          
          return dateBNum - dateANum;
        });

        setLocations(locationList);
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setLocations([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchLocations();

    return () => {
      cancelled = true;
    };
  }, []);

  return { locations, loading, error };
}

export default useUserAddedLocations;
